// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1ZlhC","productName":"Table_productName__k3HqH"};